module.exports = __webpack_public_path__ + "5bfc7613dfe72e6abbc1205fc3476b24.png";